import { render, staticRenderFns } from "./ChatCardContent.vue?vue&type=template&id=2e3f66c7&"
import script from "./ChatCardContent.vue?vue&type=script&lang=js&"
export * from "./ChatCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCardText})
